import { ListItemButton, ListItemIcon, ListItemText, CircularProgress } from '@mui/material';

function AcquisitionMenuItem({ icon, onClick, text, isLoading = false, ...props }) {
  return (
    <ListItemButton onClick={onClick} disabled={isLoading} {...props}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText secondary={text} />
      {isLoading && <CircularProgress size={16} sx={{ ml: 1 }} />}
    </ListItemButton>
  );
}

export default AcquisitionMenuItem;
